var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMutespeaker(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 384 384",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#3e98c7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M288 192c0-37.653-21.76-70.187-53.333-85.867v47.147l52.373 52.373c.64-4.48.96-9.066.96-13.653zM341.333 192c0 20.053-4.373 38.933-11.52 56.32l32.32 32.32C376 254.08 384 224 384 192c0-91.307-63.893-167.68-149.333-187.093V48.96C296.32 67.307 341.333 124.373 341.333 192z",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192 21.333L147.413 65.92 192 110.507z",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2 0L0 27.2 100.8 128H0v128h85.333L192 362.667V219.2l90.773 90.773c-14.293 10.987-30.4 19.84-48.107 25.173V379.2c29.333-6.72 56.107-20.16 78.613-38.613L356.8 384l27.2-27.2-192-192L27.2 0z",
    "data-original": "#000000"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMutespeaker);
export default __webpack_public_path__ + "static/media/mutespeaker.2964a69097852dda4a600cc2d5dc119e.svg";
export { ForwardRef as ReactComponent };